export const CLICK_TO_PAY_PAYMENT_METHOD_NAME = "ClickToPay";
